import { baseIntegration } from "./base";
import { RetailerUserAuthenticationEventEntity } from "@shared/services/event_tracking/entities/retailer_user_authentication_event_entity";
import { EventTracking } from "@shared/services/event_tracking/events";
import RetailerUserAuthenticationModalStore from "@retailer/svelte/stores/RetailerUserAuthenticationModalStore";
import Banner from "@retailer/svelte/ControlStateUserAuthentication/Ohlq/OhlqBanner.svelte";
import Cta from "@retailer/svelte/ControlStateUserAuthentication/Ohlq/OhlqCta.svelte";
import CartCta from "@retailer/svelte/ControlStateUserAuthentication/Ohlq/OhlqCartCta.svelte";
import PlpCta from "@retailer/svelte/ControlStateUserAuthentication/Ohlq/OhlqPlpCta.svelte";
import ActionBar from "@retailer/svelte/ControlStateUserAuthentication/Ohlq/OhlqActionBarCta.svelte";
import AuthenticationModal from "@retailer/svelte/ControlStateUserAuthentication/Ohlq/AuthenticationModal.svelte";
import { OHLQ_DISTRIBUTOR_ID } from "./constants";

import type { ControlStateIntegration } from "./base";

// Re-export for backward compatibility
export { OHLQ_DISTRIBUTOR_ID };

export const ohlq: ControlStateIntegration = {
  ...baseIntegration,
  state: "OH",
  text1: "",
  text2: "",
  connectCta: "Connect WSC Account",
  verifyCta: "Verify",
  pendingDescription: "Connect your Wholesale Cloud Account to order this item.",
  invalidDescription: "Verify your Wholesale Cloud Account to order this item.",
  invalidTitle: "We can’t verify your Wholesale Cloud Account.",
  actionBarTitle: "Introducing OHLQ Ohio Liquor",
  actionBarDescription: "From OHLQ Ohio Liquor",
  startVerification: (status, attrs = {}) => {
    let entity = new RetailerUserAuthenticationEventEntity({
      distributorId: OHLQ_DISTRIBUTOR_ID,
      ...attrs,
      authenticationStatus: status,
    });
    EventTracking.trackClick("retailer_user_authentication_flow", [entity]);
    RetailerUserAuthenticationModalStore.set({ open: true, distributorId: null });
  },
  bannerComponent: Banner,
  ctaComponent: Cta,
  cartCtaComponent: CartCta,
  plpCtaComponent: PlpCta,
  actionBarCtaComponent: ActionBar,
  authenticationModalComponent: AuthenticationModal,
};
